import React, { useState, useEffect } from "react";
import {
  Container,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TablePagination,
  TextField,
  Paper,
  Typography,
  Box,
  FormControl,
  InputLabel,
  Select,
  MenuItem,
  Autocomplete,
  Button,
  FormControlLabel,
  Switch,
  Alert,
} from "@mui/material";
import { ArrowDropDown, DownloadOutlined, Search } from "@mui/icons-material";

import moment from "moment";

import axios from "axios";
import { getRequest, server } from "../../config";
import PartnerProfile from "../PartnerProfile";

const PartnerManger = ({ servingPinCodes }) => {
  const [customerList, setcustomerList] = useState([]);
  const [searchQuery, setSearchQuery] = useState("");
  const [totalCount, setTotalCount] = useState(0);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [selectedCity, setSelectedCity] = useState("");
  const [allCities, setallCities] = useState([]);
  const [backData, setbackData] = useState([]);
  const [actualValue, setactualValue] = useState({ name: "All Cities" });
  const [partnerPanel, setpartnerPanel] = useState(null);
  const [allCategories, setallCategories] = useState([]);
  const [partnerList, setpartnerList] = useState([]);
  const [customers, setcustomers] = useState([]);
  const [selectedPartner, setselectedPartner] = useState(null);
  const [partnerType, setpartnerType] = useState([]);

  const [categoryValue, setcategoryValue] = useState({
    name: "All Categories",
  });
  const [selectedCategory, setselectedCategory] = useState("");
  useEffect(() => {
    fetchUsers();
  }, [searchQuery, page, rowsPerPage, categoryValue]);
  useEffect(() => {
    fetchCategories();
  }, []);

  const fetchUsers = async () => {
    const filter = {
      where: {
        or: [
          { name: { like: `%${searchQuery}%` } },
          { email: { like: `%${searchQuery}%` } },
          { pincode: { like: `%${searchQuery}%` } },
        ],
      },
      skip: page * rowsPerPage,
      limit: rowsPerPage,
    };
    const category =
      categoryValue.name == "All Categories"
        ? "{}"
        : JSON.stringify({ categoryId: categoryValue?.categoryId });
    const url =
      server.uri +
      `users?filter={"where":{ "or":[
            {"name":{"like":"${searchQuery}"}},
            {"mobileNumber":{"like":"${searchQuery}"}},
             {"pincode":{"like":"${searchQuery}"}}],"pincode":{"inq":[${servingPinCodes}]}},"skip":"${filter.skip}"
        ,"order":"createdAt desc","include":[{"relation":"services","scope":{"where":${category}}}]}`;
    console.log(url);

    const data = await getRequest(url);
    if (data) {
      setcustomers(data?.filter((item)=>item?.services?.length>0));
    }
  };
  const handleSearch = (e) => {
    setSearchQuery(e?.target?.value);
  };
  const handleChangePage = (page) => {
    setPage(page);
  };
  const handleChangeRowsPerPage = () => {};
  if (selectedPartner) {
    return (
      <PartnerProfile
        partner={selectedPartner}
        onClose={() => setselectedPartner(null)}
      />
    );
  }
  const fetchCategories = async () => {
    try {
      const uri = server.uri + "categories";
      const citiesData = await getRequest(uri);
      if (citiesData) {
        setallCategories(citiesData);
        // setbackData(citiesData);
      }
    } catch (error) {}
  };
  const handleCategorySelect = (event, value) => {
    setselectedCategory(value?.name);
    setcategoryValue(value);
    setPage(0); // Reset to the first page when city changes
  };
  return (
    <Container>
      {/* Search Bar */}
      <Box
        display="flex"
        justifyContent="space-between"
        alignItems="center"
        mb={2}
      >
        {/* Search Bar */}
        <TextField
          variant="outlined"
          placeholder="Search by name/mobile number/pincode"
          fullWidth
          value={searchQuery}
          onChange={handleSearch}
          InputProps={{
            startAdornment: <Search sx={{ color: "gray", marginRight: 1 }} />,
          }}
          sx={{ marginRight: 2 }}
        />

        {/* City Dropdown */}
        <FormControl variant="outlined" sx={{ minWidth: 200 }}>
          {/* <InputLabel>City</InputLabel> */}
          <Autocomplete
            value={categoryValue}
            onChange={handleCategorySelect}
            // label="City"
            getOptionLabel={(option) => option?.name}
            options={allCategories}
            fullWidth
            freeSolo
            renderInput={(params) => (
              <TextField
                onch
                {...params}
                label="Search Category"
                variant="outlined"
                fullWidth
              />
            )}
            renderOption={(props, option) => (
              <MenuItem {...props} key={option?.cityId}>
                {option?.name}
              </MenuItem>
            )}
          />
        </FormControl>
      </Box>
      <Typography variant="subtitle1" sx={{ textAlign: "right" }} gutterBottom>
        Total Partners: <strong>{customers?.length}</strong>
      </Typography>
      {/* Customer Table */}
      <Paper>
        <TableContainer>
          <Table>
            <TableHead>
              <TableRow
                sx={{
                  backgroundColor: "#f4f6f8", // Light background for table header
                }}
              >
                <TableCell sx={{ fontWeight: "bold" }}>ID</TableCell>
                <TableCell onClick={() => {}} sx={{ fontWeight: "bold" }}>
                  Name
                </TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Services</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Phone</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>City</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Pincode</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Status</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>isAvailable</TableCell>
                <TableCell sx={{ fontWeight: "bold" }}>Joined At</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {customers?.map((customer) => (
                <TableRow
                  sx={{
                    "&:nth-of-type(even)": {
                      backgroundColor: "#f9fafb", // Alternate row color for better readability
                    },
                  }}
                  key={customer.userId}
                >
                  <TableCell>{customer?.uniqueId}</TableCell>
                  <TableCell
                    onClick={() => setselectedPartner(customer)}
                    sx={{ cursor: "pointer" }}
                  >
                    {customer?.name}
                  </TableCell>
                  <TableCell>
                    {customer?.services?.map((item) => {
                      return <>{item?.name},</>;
                    })}
                  </TableCell>
                  <TableCell>{customer?.mobileNumber}</TableCell>
                  <TableCell>{customer?.city}</TableCell>
                  <TableCell>{customer?.pincode}</TableCell>
                  <TableCell>{customer?.status}</TableCell>
                  <TableCell>
                    <FormControlLabel
                      control={
                        <Switch
                          checked={customer?.isUserActive}
                          disabled
                          onChange={() => {}}
                        />
                      }
                    />
                  </TableCell>
                  <TableCell>
                    {moment(customer?.createdAt).startOf("hour").fromNow()}
                  </TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>

        {/* Pagination */}
        <TablePagination
          rowsPerPageOptions={[5, 10, 25, 50, 100, 200, 500, 1000]}
          component="div"
          count={totalCount}
          rowsPerPage={rowsPerPage}
          page={page}
          onPageChange={handleChangePage}
          onRowsPerPageChange={handleChangeRowsPerPage}
        />
      </Paper>
    </Container>
  );
};

export default PartnerManger;
